import AuthLoading from "@/common/components/authloading";

export default function () {
  return <AuthLoading defaultCliantId='6445e261-45e8-4e33-8f8c-2cf6b0c783a5'></AuthLoading>
}